import store from '../../../core/store';
import { __, redirect } from '../../../core/utils';
import { getPreferences, updatePreferences } from '../profile';

const SIDEBAR_SUBMODULE_PREFERENCE_PREFIX = 'sidebar.last_submodule';

const SIDEBAR_SPECIAL_MODULE_PREFIXES = [
  {
    moduleKey: 'project_settings',
    prefixes: [
      '/projects/:id/stages',
      '/projects/:id/general',
      '/stages/:id/teams',
      '/stages/:id/approvers',
      '/import/:id',
    ],
  },
  {
    moduleKey: 'plans',
    prefixes: [
      '/stages/:id/plans',
      '/stages/:id/deliveries',
      '/stages/:id/approvals',
    ],
  },
  {
    moduleKey: 'specifications',
    prefixes: [
      '/stages/:id/specifications',
      '/stages/:id/specification_deliveries',
      '/stages/:id/specification_approvals',
    ],
  },
  {
    moduleKey: 'timesheets',
    prefixes: ['/timesheets', '/timesheet_report'],
  },
  {
    moduleKey: 'companies_and_users',
    prefixes: ['/companies', '/address_book'],
  },
];

const SUPERADMIN_SIDEBAR_ITEMS_CONFIG = [
  {
    permission: 'list_companies',
    titleKey: 'modules.submodules.title.companies',
    link: '/superadmin/companies',
  },
  {
    permission: 'list_users',
    titleKey: 'modules.submodules.title.users',
    link: '/superadmin/users',
  },
  {
    permission: 'list_raw_materials',
    titleKey: 'modules.submodules.title.filter-materials',
    link: '/superadmin/raw_materials',
  },
  {
    permission: 'list_materials',
    titleKey: 'modules.submodules.title.materials',
    link: '/superadmin/materials',
  },
  {
    permission: 'list_languages',
    titleKey: 'modules.submodules.title.languages',
    link: '/superadmin/languages',
  },
  {
    permission: 'list_translations',
    titleKey: 'modules.submodules.title.translations',
    link: '/superadmin/translations',
  },
  {
    permission: 'list_note_categories',
    titleKey: 'modules.submodules.title.instruction-categories',
    link: '/superadmin/note_categories',
  },
  {
    permission: 'list_notes',
    titleKey: 'modules.submodules.title.instructions',
    link: '/superadmin/notes',
  },
  {
    permission: 'list_products',
    titleKey: 'modules.submodules.title.products',
    link: '/superadmin/products',
  },
  {
    permission: 'list_raw_colors',
    titleKey: 'modules.submodules.title.raw-colors',
    link: '/superadmin/raw_colors',
  },
  {
    permission: 'list_colors',
    titleKey: 'modules.submodules.title.colors',
    link: '/superadmin/colors',
  },
  {
    permission: 'list_paper_sizes',
    titleKey: 'modules.submodules.title.paper-sizes',
    link: '/superadmin/paper_sizes',
  },
  {
    permission: 'list_product_attribute_template_groups',
    titleKey: 'modules.submodules.title.product-attribute-template-groups',
    link: '/superadmin/product_attribute_template_groups',
  },
  {
    permission: 'list_product_attribute_template_fields',
    titleKey: 'modules.submodules.title.product-attribute-template-fields',
    link: '/superadmin/product_attribute_template_fields',
  },
  {
    permission: 'list_regions',
    titleKey: 'modules.submodules.title.regions',
    link: '/superadmin/regions',
  },
  {
    permission: 'list_countries',
    titleKey: 'modules.submodules.title.countries',
    link: '/superadmin/countries',
  },
  {
    permission: 'list_unit_groups',
    titleKey: 'modules.submodules.title.unit-groups',
    link: '/superadmin/unit_groups',
  },
  {
    permission: 'list_units',
    titleKey: 'modules.submodules.title.units',
    link: '/superadmin/units',
  },
  {
    permission: 'list_building_types',
    titleKey: 'modules.submodules.title.building-types',
    link: '/superadmin/building_types',
  },
  {
    permission: 'list_functional_spaces',
    titleKey: 'modules.submodules.title.functional-spaces',
    link: '/superadmin/functional_spaces',
  },
  {
    permission: 'list_disciplines',
    titleKey: 'modules.submodules.title.disciplines',
    link: '/superadmin/disciplines',
  },
  {
    permission: 'list_product_categories',
    titleKey: 'modules.submodules.title.product-categories',
    link: '/superadmin/product_categories',
  },
  {
    permission: 'list_product_groups',
    titleKey: 'modules.submodules.title.product-groups',
    link: '/superadmin/product_groups',
  },
  {
    permission: 'list_product_subgroups',
    titleKey: 'modules.submodules.title.product-subgroups',
    link: '/superadmin/product_subgroups',
  },
  {
    permission: 'list_specification_groups',
    titleKey: 'modules.submodules.title.specification-groups',
    link: '/superadmin/specification_groups',
  },
  {
    permission: 'list_specification_subgroups',
    titleKey: 'modules.submodules.title.specification-subgroups',
    link: '/superadmin/specification_subgroups',
  },
  {
    permission: 'list_boq_template_groups',
    titleKey: 'modules.submodules.title.boq-template-groups',
    link: '/superadmin/boq_template_groups',
  },
  {
    permission: 'list_boq_template_subgroups',
    titleKey: 'modules.submodules.title.boq-template-subgroups',
    link: '/superadmin/boq_template_subgroups',
  },
  {
    permission: 'list_boq_template_calculations',
    titleKey: 'modules.submodules.title.boq-template-calculations',
    link: '/superadmin/boq_template_calculations',
  },
  {
    permission: 'list_boq_supply_types',
    titleKey: 'modules.submodules.title.boq-supply-types',
    link: '/superadmin/boq_supply_types',
  },
  {
    permission: 'list_boq_supply_type_groups',
    titleKey: 'modules.submodules.title.boq-supply-type-groups',
    link: '/superadmin/boq_supply_type_groups',
  },
  {
    permission: 'list_filters',
    titleKey: 'modules.submodules.title.filters',
    link: '/superadmin/filters',
  },
];

const resolveSidebarLink = (item) => {
  if (!item?.link) {
    return null;
  }

  const link = item.link();

  return _.isString(link) && !_.isEmpty(link) ? link : null;
};

const normalizeSidebarLink = (link) => {
  if (!_.isString(link) || _.isEmpty(link)) {
    return null;
  }

  const path = _.first(link.split(/[?#]/));

  if (!path) {
    return null;
  }

  const normalized = path.replace(/\/\d+(?=\/|$)/g, '/:id');

  return normalized !== '/' ? _.trimEnd(normalized, '/') : normalized;
};

const getSidebarLinkItems = (items = []) => {
  return _.flatMap(items, (item) => {
    const link = resolveSidebarLink(item);
    const current = link
      ? [
          {
            item,
            link,
            key: normalizeSidebarLink(link),
          },
        ]
      : [];

    return [...current, ...getSidebarLinkItems(item.items || [])];
  }).filter(({ key }) => !_.isEmpty(key));
};

const isSidebarItemActive = (item) => {
  if (!item || _.isNil(item.active)) {
    return false;
  }

  return _.isFunction(item.active) ? item.active() : item.active;
};

const getSidebarModuleKey = (items) => {
  const keys = _.map(items, 'key');
  const firstKey = _.get(_.first(items), 'key');
  const matchedModule = _.find(SIDEBAR_SPECIAL_MODULE_PREFIXES, ({ prefixes }) =>
    _.some(keys, (key) =>
      _.some(prefixes, (prefix) => _.startsWith(key, prefix))
    )
  );

  if (matchedModule) {
    return matchedModule.moduleKey;
  }

  if (_.startsWith(firstKey, '/stages/:id/')) {
    const segment = _.get(_.split(firstKey, '/'), 3);

    return segment || null;
  }

  return _.get(_.split(firstKey, '/'), 1, null);
};

const getSavedSidebarSubmoduleLink = ({
  moduleKey,
  items = [],
  fallbackLink,
}) => {
  const sidebarItems = _.uniqBy(getSidebarLinkItems(items), 'key');
  const resolvedModuleKey = moduleKey || getSidebarModuleKey(sidebarItems);
  const resolvedFallbackLink =
    fallbackLink || _.get(_.first(sidebarItems), 'link') || null;

  if (_.size(sidebarItems) <= 1 || _.isEmpty(resolvedModuleKey)) {
    return Promise.resolve(resolvedFallbackLink);
  }

  return getPreferences(
    `${SIDEBAR_SUBMODULE_PREFERENCE_PREFIX}.${resolvedModuleKey}`
  )
    .then(({ response }) => {
      const savedItemKey = _.get(response, 'data.item_key');
      const savedItem = _.find(sidebarItems, ['key', savedItemKey]);

      return _.get(savedItem, 'link') || resolvedFallbackLink;
    })
    .catch(() => resolvedFallbackLink);
};

export const redirectToSidebarSubmodule = ({
  moduleKey,
  items = [],
  fallbackLink,
  replace = false,
}) => {
  return getSavedSidebarSubmoduleLink({
    moduleKey,
    items,
    fallbackLink,
  }).then((link) => {
    if (link) {
      redirect(link, replace);
    }

    return link;
  });
};

const getCurrentNormalizedPath = () => {
  return normalizeSidebarLink(
    _.get(store.getState(), 'router.location.pathname')
  );
};

const persistSidebarSubmodule = (options) => {
  if (!options || _.isEmpty(options.items)) {
    return;
  }

  const items = _.uniqBy(getSidebarLinkItems(options.items), 'key');
  const moduleKey = options.moduleKey || getSidebarModuleKey(items);

  if (_.size(items) <= 1 || _.isEmpty(moduleKey)) {
    return;
  }

  const activeItem =
    _.find(items, ({ key }) => key === getCurrentNormalizedPath()) ||
    _.findLast(items, ({ item }) => isSidebarItemActive(item));

  if (!activeItem) {
    return;
  }

  updatePreferences(`${SIDEBAR_SUBMODULE_PREFERENCE_PREFIX}.${moduleKey}`, {
    item_key: activeItem.key,
  });
};

export const toggleSidebar = () => {
  return store.dispatch({
    type: 'general.sidebar/TOGGLE_SIDEBAR',
  });
};

export const toggleSidebarCollapse = (key) => {
  return store.dispatch({
    type: 'general.sidebar/TOGGLE_SIDEBAR_COLLAPSE',
    key,
  });
};

export const hideSidebar = () => {
  return store.dispatch({
    type: 'general.sidebar/HIDE_SIDEBAR',
  });
};

export const createSidebar = (options) => {
  const result = store.dispatch({
    type: 'general.sidebar/CREATE_SIDEBAR',
    options,
  });

  persistSidebarSubmodule(options);

  return result;
};

export const updateSidebar = (key, value) => {
  return store.dispatch({
    type: 'general.sidebar/UPDATE_SIDEBAR',
    key,
    value,
  });
};

const getSuperadminSidebarItems = (superadmin = {}) => {
  return _.chain(SUPERADMIN_SIDEBAR_ITEMS_CONFIG)
    .filter(({ permission }) => superadmin[permission])
    .map(({ titleKey, link }) => ({
      title: __(titleKey),
      link,
    }))
    .value();
};

export const getSuperadminSidebarModule = ({
  superadmin = {},
  pathname = null,
} = {}) => {
  const items = getSuperadminSidebarItems(superadmin);

  return {
    title: __('modules.title.superadmin'),
    moduleKey: 'superadmin',
    fallbackLink: _.get(_.first(items), 'link', null),
    items: _.map(items, (item) => ({
      ...item,
      active: pathname ? item.link === pathname : false,
      link: () => item.link,
    })),
  };
};

export const createSuperadminSidebar = () => {
  const state = store.getState(); //get current redux state

  const superadmin = _.get(state, 'auth.superadmin'); //get all superadmin privileges
  const pathname = state.router.location.pathname; //get current pathname from 'router' reducer

  return createSidebar(
    getSuperadminSidebarModule({
      superadmin,
      pathname,
    })
  );
};
